import React, { useCallback, useMemo } from "react";
import { FiCamera } from "react-icons/fi";

export const FormInputFile: React.FunctionComponent<{
  placeholder: string;
  icon: "camera";
  selectedFile: File;
  setFile: (file: File) => void;
}> = ({ placeholder, icon, selectedFile, setFile }) => {
  const handleFileChange = useCallback(
    (e) => {
      e.preventDefault();

      setFile(e.target.files[0]);
    },
    [setFile]
  );

  const iconComponent = useMemo(() => {
    if (!icon) {
      return null;
    }
    switch (icon) {
      case "camera":
        return (
          <FiCamera
            className="text-success font-bold mr-2"
            style={{ width: 18, height: 18 }}
          />
        );
      default:
        return null;
    }
  }, [icon]);

  return (
    <React.Fragment>
      {!selectedFile ? (
        <>
          <label
            htmlFor="upload"
            className="mb-0"
            style={{ cursor: "pointer" }}
          >
            <div className="flex items-center">
              {iconComponent}
              <p className="text-success font-bold mb-0">{placeholder}</p>
            </div>
          </label>
          <input
            type="file"
            id="upload"
            className="form-control-file"
            onChange={(e) => handleFileChange(e)}
            hidden
            value=""
            accept="image/*"
          />
        </>
      ) : (
        <div className="flex justify-between items-center">
          <div className="flex items-center w-full">
            <FiCamera
              className="text-success font-bold mr-2"
              style={{ width: 18, height: 18 }}
            />
            <p className="text-success font-bold text-truncate mb-0">
              {selectedFile?.name}
            </p>
          </div>
          <button
            onClick={() => setFile(null)}
            type="button"
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      )}
    </React.Fragment>
  );
};
